// extracted by mini-css-extract-plugin
export default {"formContainer":"FTMFormBlock_formContainer__xr0ll"};